import { useTranslation } from "react-i18next";
import SegmentedControl from "../../../common/components/SegmentedControl/SegmentedControl";
import type { Cadence } from "../types";

interface CadenceSelectorProps {
  value: Cadence;
  onChange: (next: Cadence) => void;
  disabled?: boolean;
}

const CADENCES: Cadence[] = ["weekly", "monthly", "quarterly"];

const CadenceSelector = ({ value, onChange, disabled }: CadenceSelectorProps) => {
  const { t } = useTranslation();
  return (
    <SegmentedControl<Cadence>
      options={CADENCES.map((c) => ({
        value: c,
        label: t(`pages.statistics.reports.cadence.${c}`),
        activeBgColor: "bg-green-500",
        activeColor: "text-white",
      }))}
      value={value}
      onChange={onChange}
      disabled={disabled}
      variant="pill"
      size="sm"
    />
  );
};

export default CadenceSelector;
